import { FAST_API_BASE_URL } from "constants";
import { createContext, useContext, useEffect, useState } from "react";
import { useUser } from "./UserContext";
import axios from "axios";

const SiteContext = createContext();

export const SitesProvider = ({ children }) => {
   const { googleUser, setGoogleUser } = useUser();
      const [sites, setSites] = useState([]);
        const customUser = localStorage.getItem("custom") === "true";
  const customEmail = localStorage.getItem("customEmail");

  const fetchSites = async () => {
    try {
      const res = await axios.get(`${FAST_API_BASE_URL}/api/user/domains`, {
        headers: {
          "EMAIL": googleUser?.email || (customUser ? customEmail : "")
        },
      });

      if (res.data?.result && Array.isArray(res.data.result)) {
        setSites(res.data.result);
      }
    } catch (error) {
      console.error("Failed to fetch sites:", error);
    }
  };

//         useEffect(() => {
//   fetchSites();
// }, []);


  return (
    <SiteContext.Provider value={{ sites,setSites,fetchSites }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSites = () => useContext(SiteContext);
